import type { PropsWithChildren } from 'react';
import type { LayoutType } from '../../../types';
import { LayoutCarousel } from './LayoutCarousel';
import { LayoutList } from './LayoutList';

interface LayoutProps extends PropsWithChildren {
  type: LayoutType;
  compact: boolean;
  viewWidth: number;
  viewHeight: number;
  slideIndex?: number;
  controlsColor?: string;
}

export function Layout({ type: layoutType, children, ...props }: LayoutProps) {
  const VariationComponent = {
    list: LayoutList,
    carousel: LayoutCarousel
  }[layoutType];

  if (!VariationComponent) {
    throw new Error(`Unknown layout "${layoutType}".`);
  }

  return <VariationComponent {...props}>{children}</VariationComponent>;
}
